'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import I18n from 'I18n';
import { makeOptionsFromProperty, makeOptionsFromPropertyWithoutBlankOptions } from 'customer-data-property-utils/PropertyValueDisplay';
import UIStatusDot from 'UIComponents/tag/UIStatusDot';
import UISelect from 'UIComponents/input/UISelect';
import PropertyPropType from '../utils/propTypes/PropertyPropType';
import { getTransferrableProps } from '../utils/getTransferrableProps';
import refObject from 'UIComponents/utils/propTypes/refObject';
const PRIORITY_TO_STATUS_TAG_TYPE_MAP = {
  low: 'active',
  medium: 'warning',
  high: 'danger'
};
const propTypes = {
  defaultValue: PropTypes.node,
  inputRef: refObject.isRequired,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  property: PropertyPropType.isRequired,
  isRequired: PropTypes.bool,
  placeholder: PropTypes.node,
  value: PropTypes.node
};
export default class PropertyInputPriority extends PureComponent {
  constructor(...args) {
    super(...args);

    this.getOptions = () => {
      const {
        property,
        isRequired = false
      } = this.props;
      return isRequired ? makeOptionsFromPropertyWithoutBlankOptions(property) : makeOptionsFromProperty(property);
    };

    this.renderOptionWithStatusTag = ({
      children,
      className,
      option,
      onClick,
      onMouseEnter
    }) => {
      if (!option.value) {
        return /*#__PURE__*/_jsx("li", {
          className: className,
          "data-option-value": option.value,
          children: children
        });
      }

      const statusDotUse = PRIORITY_TO_STATUS_TAG_TYPE_MAP[option.value.toLowerCase()];
      return /*#__PURE__*/_jsxs("li", {
        style: {
          padding: '8px 20px'
        },
        className: className,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        "data-option-value": option.value,
        children: [statusDotUse && /*#__PURE__*/_jsx(UIStatusDot, {
          use: statusDotUse
        }), option.text]
      });
    };

    this.renderValueWithStatusTag = ({
      value,
      text,
      buttonText
    }) => {
      if (!value) {
        return buttonText;
      }

      const statusDotUse = PRIORITY_TO_STATUS_TAG_TYPE_MAP[value.toLowerCase()];
      return /*#__PURE__*/_jsxs("div", {
        children: [statusDotUse && /*#__PURE__*/_jsx(UIStatusDot, {
          use: statusDotUse
        }), text]
      });
    };
  }

  getPlaceholder() {
    const {
      property,
      placeholder
    } = this.props;
    if (placeholder === null) return '';
    if (placeholder !== undefined) return placeholder;
    return property.placeholder || I18n.text('customerDataProperties.PropertyInput.selectPlaceholder');
  }

  getValue(value, defaultValue) {
    return String(value || defaultValue || '');
  }

  render() {
    return /*#__PURE__*/_jsx(UISelect, Object.assign({}, getTransferrableProps(this.props, ['onFocus', 'onKeyUp']), {
      options: this.getOptions(),
      placeholder: this.getPlaceholder(),
      ref: this.props.inputRef,
      value: this.getValue(this.props.value, this.props.defaultValue),
      itemComponent: this.renderOptionWithStatusTag,
      valueRenderer: this.renderValueWithStatusTag
    }));
  }

}
PropertyInputPriority.propTypes = propTypes;